import Vue from 'vue'

import bsCol from './views/components/bootstrap/bs-col.vue';
Vue.component('bs-col', bsCol);

import bsContainer from './views/components/bootstrap/bs-container.vue';
Vue.component('bs-container', bsContainer);

import bsFormGroup from './views/components/bootstrap/bs-form-group.vue';
Vue.component('bs-form-group', bsFormGroup);

import bsLabel from './views/components/bootstrap/bs-label.vue';
Vue.component('bs-label', bsLabel);

import bsRow from './views/components/bootstrap/bs-row.vue';
Vue.component('bs-row', bsRow);

import controlValidatorGroup from './views/components/control-validator-group.vue';
Vue.component('control-validator-group', controlValidatorGroup);

import imagePreviewModal from './views/components/image-preview-modal.vue';
Vue.component('image-preview-modal', imagePreviewModal);

import ucCropWindow from './views/components/uc-crop-window.vue';
Vue.component('uc-crop-window', ucCropWindow);

import ucMap from './views/components/uc-map.vue';
Vue.component('uc-map', ucMap);

import uiFileInput from './views/components/ui-file-input.vue';
Vue.component('ui-file-input', uiFileInput);

import uiMaps from './views/components/ui-maps/ui-maps.vue';
Vue.component('ui-maps', uiMaps);

import defaultMenu from './views/layouts/default/default-menu.vue';
Vue.component('default-menu', defaultMenu);

import defaultNavigator from './views/layouts/default/default-navigator.vue';
Vue.component('default-navigator', defaultNavigator);

import defaultTitle from './views/layouts/default/default-title.vue';
Vue.component('default-title', defaultTitle);

import ucHeaderIconMenu from './views/layouts/header/uc-header-ico-menu.vue';
Vue.component('uc-header-icon-menu', ucHeaderIconMenu);

import ucHeaderIconPanel from './views/layouts/header/uc-header-ico-panel.vue';
Vue.component('uc-header-icon-panel', ucHeaderIconPanel);

import ucHeaderLogo from './views/layouts/header/uc-header-logo.vue';
Vue.component('uc-header-logo', ucHeaderLogo);

import ucHeaderTitleDefault from './views/layouts/header/uc-header-title-default.vue';
Vue.component('uc-header-title-default', ucHeaderTitleDefault);

import ucNotifications from './views/layouts/header/uc-notifications.vue';
Vue.component('uc-notifications', ucNotifications);

import ucPageHeader from './views/layouts/header/uc-page-header.vue';
Vue.component('uc-page-header', ucPageHeader);

import ucProfileBlock from './views/layouts/header/uc-profile-block.vue';
Vue.component('uc-profile-block', ucProfileBlock);

import lHeader from './views/layouts/l-header.vue';
Vue.component('l-header', lHeader);

import lNavigation from './views/layouts/l-navigation.vue';
Vue.component('l-navigation', lNavigation);

import lSideMenu from './views/layouts/l-side-menu.vue';
Vue.component('l-side-menu', lSideMenu);

import appLayout from './views/layouts/layout.vue';
Vue.component('app-layout', appLayout);

import ucMenuIcon from './views/layouts/menu/uc-menu-icon.vue';
Vue.component('uc-menu-icon', ucMenuIcon);

import ucMenuItem from './views/layouts/menu/uc-menu-item.vue';
Vue.component('uc-menu-item', ucMenuItem);

import ucMenuSub from './views/layouts/menu/uc-menu-sub.vue';
Vue.component('uc-menu-sub', ucMenuSub);

import ucMenu from './views/layouts/menu/uc-menu.vue';
Vue.component('uc-menu', ucMenu);

import ucImage from './views/pages/components/uc-image.vue';
Vue.component('uc-image', ucImage);

import ucPage from './views/pages/components/uc-page.vue';
Vue.component('uc-page', ucPage);

import banners from './views/pages/page-banners.vue';
Vue.component('banners', banners);

import organization from './views/pages/page-contracts-organization.vue';
Vue.component('organization', organization);

import contracts from './views/pages/page-contracts.vue';
Vue.component('contracts', contracts);

import gpsTracker from './views/pages/page-gps-tracker.vue';
Vue.component('gps-tracker', gpsTracker);

import jobOpenings from './views/pages/page-job_openings.vue';
Vue.component('job_openings', jobOpenings);

import kpiUserHistory from './views/pages/page-kpi-user-history.vue';
Vue.component('kpi-user-history', kpiUserHistory);

import kpiUser from './views/pages/page-kpi-user.vue';
Vue.component('kpi-user', kpiUser);

import kpi from './views/pages/page-kpi.vue';
Vue.component('kpi', kpi);

import pagemap from './views/pages/page-map.vue';
Vue.component('pagemap', pagemap);

import devices from './views/pages/page-mobile-users-devices.vue';
Vue.component('devices', devices);

import mobileUsers from './views/pages/page-mobile-users.vue';
Vue.component('mobile-users', mobileUsers);

import news from './views/pages/page-news.vue';
Vue.component('news', news);

import partners from './views/pages/page-partners.vue';
Vue.component('partners', partners);

import seo from './views/pages/page-seo.vue';
Vue.component('seo', seo);

import users from './views/pages/page-users.vue';
Vue.component('users', users);




// WEBPACK FOOTER //
// ./scripts/load.ts